// extracted by mini-css-extract-plugin
export default {"p_content":"_718705d5e2"};